export function capitalizeFirstWord(input: string = "") {
  const words = input.split(" "); // Split the string by spaces
  if (words.length === 0) return input; // Handle empty strings

  const firstWord = words[0].charAt(0).toUpperCase() + words[0].slice(1); // Capitalize the first word
  const remainingWords = words.slice(1).join(" "); // Join the rest of the words back into a string

  return `${firstWord} ${remainingWords}`.trim(); // Combine the first word and the rest
}
